import { CustomerServiceOutlined, DownloadOutlined } from "@ant-design/icons"
import { Button } from "antd"
import type { ButtonProps } from "antd"
import { useDownload } from "~/common/media/useDownload"
import { AnalyticsAction } from "~/components/Analytics"

type DownloadButtonProps = Pick<ButtonProps, "size" | "icon"> & {
  url?: string
  kind: "video" | "music"
  label?: string
  prefix: string
}

export const DownloadButton = ({
  url,
  kind,
  label,
  prefix,
  size,
  icon,
}: DownloadButtonProps) => {
  const { download: downloadFile, downloading } = useDownload()
  const isMusic = kind === "music"
  const text = label || (isMusic ? "下载背景音乐" : "下载视频")

  const download = () => {
    if (!url) return
    void downloadFile(
      url,
      `source-video-${isMusic ? "bgm-" : ""}${Date.now()}.${isMusic ? "mp3" : "mp4"}`,
      `${text}失败，请重试`,
    )
  }

  return (
    <AnalyticsAction
      action={isMusic ? "下载原视频背景音乐" : "下载视频"}
      prefix={prefix}
    >
      <Button
        size={size}
        disabled={!url}
        icon={
          icon === undefined ? (
            isMusic ? (
              <CustomerServiceOutlined />
            ) : (
              <DownloadOutlined />
            )
          ) : (
            icon
          )
        }
        loading={downloading}
        onClick={download}
      >
        {text}
      </Button>
    </AnalyticsAction>
  )
}
